import { getMappedLanguage } from 'i18n/helpers';
import {
  CHAT_MESSAGES_ENDPOINT,
  CHAT_ASSISTANT_MESSAGES_ENDPOINT,
  GET_CHAT_MESSAGE_ATTACHMENTS_ENDPOINT,
  GET_HISTORICAL_CHAT_MESSAGE_ENDPOINT,
} from './constants';
import { FetchHistoricalMessagesOptions } from './types';

export const validateMessageParams = (sessionId, options) => {
  if (!sessionId) {
    return new Error('A conversationId must be provided.');
  }

  const body = options?.body;
  const attachments = options?.attachments;

  if (!body && !attachments?.length) {
    return new Error(
      'Message is missing one or more of the required properties: body or attachments',
    );
  }

  return undefined;
};

export const makeGetChatMessageAttachmentsEndpoint = (id: string) => {
  return `/c/v1/chat/messages/${id}/attachments` as typeof GET_CHAT_MESSAGE_ATTACHMENTS_ENDPOINT;
};

export const makeGetHistoricalMessagesEndpoint = (
  conversationId: string,
  options: FetchHistoricalMessagesOptions,
) => {
  const endpoint = `/c/v2.1/chat/sessions/${conversationId}/messages?count=${options.count}`;
  return (
    options.before ? `${endpoint}&before=${options.before}` : endpoint
  ) as typeof GET_HISTORICAL_CHAT_MESSAGE_ENDPOINT;
};

export const makePostMessageEndpoint = ({ lang }, endpoint) => {
  const mappedLang = getMappedLanguage(lang);
  return mappedLang ? `${endpoint}?lang=${mappedLang}` : endpoint;
};

export const makePostChatMessageEndpoint = (parameters) => {
  return makePostMessageEndpoint(
    parameters,
    CHAT_MESSAGES_ENDPOINT,
  ) as typeof CHAT_MESSAGES_ENDPOINT;
};

export const makePostChatAssistantMessageEndpoint = (parameters) => {
  return makePostMessageEndpoint(
    parameters,
    CHAT_ASSISTANT_MESSAGES_ENDPOINT,
  ) as typeof CHAT_ASSISTANT_MESSAGES_ENDPOINT;
};
